import React from 'react'
import { FormattedMessage } from 'react-intl'
import { number, string, shape, oneOfType, func } from 'prop-types'
import { Check } from '@assets/icons'
import { Row, Col, List, Hide } from '@gympass/yoga'
import Container from '@components/Container'
import { benefitAccess, benefitIndicators, benefitManagement } from '@assets'
import OfferCard from '../../components/OfferCard'
import OfferActions from '../../components/OfferActions'

import {
  CompanyInvestmentWrapper,
  Title,
  Subtitle,
  ListWrapper,
  ListItem,
  ListIcon,
  OrderableColumn,
  ListItemDescription,
  DisclaimerWrapper,
} from './CompanyInvestment.style'

export default function CompanyInvestment({
  step,
  path,
  actions,
  onNext,
  contact,
}) {
  return (
    <CompanyInvestmentWrapper>
      <Container>
        <Row>
          <Col xxs={12}>
            <Title>
              <FormattedMessage
                id="smb_acquisition_commercial_offer.commercial_offer.title"
                values={{
                  name: contact.firstName,
                }}
              />
            </Title>
          </Col>
        </Row>

        <Row>
          <OrderableColumn xxs={12} md={6} xl-start={8} xl={5}>
            <OfferCard
              step={step}
              path={path}
              actions={actions}
              onNext={onNext}
              contact={contact}
            />
            <DisclaimerWrapper>
              <FormattedMessage id="smb_acquisition_commercial_offer.commercial_offer.disclaimer" />
            </DisclaimerWrapper>
          </OrderableColumn>

          <Col xxs={12} md={6}>
            <Subtitle>
              <FormattedMessage id="smb_acquisition_commercial_offer.commercial_offer.subtitle" />
            </Subtitle>

            <Hide xl-start>
              <ListWrapper>
                <List divided={false}>
                  <ListItem>
                    <ListIcon src={Check} alt="Primeiro benefício" />
                    <ListItemDescription>
                      <FormattedMessage id="smb_acquisition_commercial_offer.benefits.company.benefit_1.description" />
                    </ListItemDescription>
                  </ListItem>

                  <ListItem>
                    <ListIcon src={Check} alt="Segundo benefício" />
                    <ListItemDescription>
                      <FormattedMessage id="smb_acquisition_commercial_offer.benefits.company.benefit_2.description" />
                    </ListItemDescription>
                  </ListItem>

                  <ListItem>
                    <ListIcon src={Check} alt="Terceiro benefício" />
                    <ListItemDescription>
                      <FormattedMessage id="smb_acquisition_commercial_offer.benefits.company.benefit_3.description" />
                    </ListItemDescription>
                  </ListItem>
                </List>
              </ListWrapper>
            </Hide>

            <Hide xxs xs sm md lg>
              <ListWrapper>
                <ListItem>
                  <img src={benefitAccess} alt="Primeiro benefício" />
                  <ListItemDescription>
                    <FormattedMessage id="smb_acquisition_commercial_offer.benefits.company.benefit_1.description" />
                  </ListItemDescription>
                </ListItem>

                <ListItem>
                  <img src={benefitManagement} alt="Segundo benefício" />
                  <ListItemDescription>
                    <FormattedMessage id="smb_acquisition_commercial_offer.benefits.company.benefit_2.description" />
                  </ListItemDescription>
                </ListItem>

                <ListItem>
                  <img src={benefitIndicators} alt="Terceiro benefício" />
                  <ListItemDescription>
                    <FormattedMessage id="smb_acquisition_commercial_offer.benefits.company.benefit_3.description" />
                  </ListItemDescription>
                </ListItem>
              </ListWrapper>
            </Hide>

            <OfferActions contact={contact} />
          </Col>
        </Row>
      </Container>
    </CompanyInvestmentWrapper>
  )
}

CompanyInvestment.propTypes = {
  contact: shape({
    employeesNumber: oneOfType([number, string]),
  }).isRequired,
  path: string.isRequired,
  actions: shape({
    setFunnelStage: func,
    setDataLayer: func,
  }).isRequired,
  step: number.isRequired,
  onNext: func,
}

CompanyInvestment.defaultProps = {
  onNext: undefined,
}
